import type {
	RecentTimelineItemTypeFilterEnum,
	TimelineHorizonEnum,
	TimelineItemCategoryEnum,
	TimelineItemSubcategoryEnum,
	UpcomingTimelineItemTypeFilterEnum,
} from "web_myplann/Infrastructure/Api/Api";

const NOTIFICATION_CENTER_ROOT = ["myplann", "notification-center"] as const;

export const NotificationCenterKeys = {
	all: NOTIFICATION_CENTER_ROOT,
	upcoming: (
		horizon: TimelineHorizonEnum,
		type: UpcomingTimelineItemTypeFilterEnum,
		subcategories?: TimelineItemSubcategoryEnum[],
	) =>
		[
			...NotificationCenterKeys.all,
			"upcoming",
			horizon,
			type,
			subcategories ?? null,
		] as const,
	upcomingPreview: (
		horizon: TimelineHorizonEnum,
		type: UpcomingTimelineItemTypeFilterEnum,
		limit: number,
	) =>
		[
			...NotificationCenterKeys.all,
			"upcoming-preview",
			horizon,
			type,
			limit,
		] as const,
	resolvingNow: (
		type?: UpcomingTimelineItemTypeFilterEnum,
		limit?: number,
		subcategories?: TimelineItemSubcategoryEnum[],
	) =>
		[
			...NotificationCenterKeys.all,
			"resolving-now",
			type,
			limit,
			subcategories ?? null,
		] as const,
	recentAll: [...NOTIFICATION_CENTER_ROOT, "recent"] as const,
	recent: (
		type: RecentTimelineItemTypeFilterEnum,
		subcategories?: TimelineItemSubcategoryEnum[],
	) =>
		[...NotificationCenterKeys.recentAll, type, subcategories ?? null] as const,
	recentPreview: (
		categories: TimelineItemCategoryEnum[],
		dateFrom: string,
		dateTo: string,
		limit: number,
	) =>
		[
			...NotificationCenterKeys.all,
			"recent-preview",
			categories,
			dateFrom,
			dateTo,
			limit,
		] as const,
};
